import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SetField } from '../components/Table/fields/SetField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SelectField } from '../components/Table/fields/SelectField';
import { TimeField } from '../components/Table/fields/TimeField';
import { activityExtra } from './activityExtra';
import { DateField } from '../components/Table/fields/DateField';
import { competitorPriceWithoutActivity } from './competitorPriceWithoutActivity';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { ActivityWithOutServiceProvider } from '../types/entities/ActivityWithOutServiceProvider';

export const activityWithOutServiceProvider: SchemaWithClient<ActivityWithOutServiceProvider> = {
  name: 'Activity',
  pluralName: 'Activities',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      defaultShow: true,
    },
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      defaultShow: false,
    },
    activity_category: {
      name: 'Activity Category',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityCategory),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.activityCategory
      ),
      url: enumItems.activityCategory.client.getAllPath,
      tempSchema: enumItems.activityCategory,
      switchboard: true,
      defaultShow: true,
    },
    activity_type: {
      name: 'Activity Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.activityType
      ),
      url: enumItems.activityType.client.getAllPath,
      tempSchema: enumItems.activityType,
      switchboard: true,
      defaultShow: true,
    },
    activity_extras: {
      name: 'Activity Extras',
      fieldRenderer: SetField.tableAdapter(activityExtra),
      slidePaneFieldRenderer: SPSetField.tableAdapter(activityExtra),
      url: activityExtra.client.getAllPath,
      tempSchema: activityExtra,
      multiSwitchboard: true,
      defaultShow: false,
    },
    competitor_prices: {
      name: 'Competitor Prices',
      fieldRenderer: SetField.tableAdapter(competitorPriceWithoutActivity),
      slidePaneFieldRenderer: SPSetField.tableAdapter(
        competitorPriceWithoutActivity
      ),
      url: competitorPriceWithoutActivity.client.getAllPath,
      tempSchema: competitorPriceWithoutActivity,
      multiSwitchboard: true,
      defaultShow: false,
    },
    pickup_place: {
      name: 'Pickup Place',
      fieldRenderer: SelectField.tableAdapter(enumItems.pickupPlace),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.pickupPlace),
      url: enumItems.pickupPlace.client.getAllPath,
      tempSchema: enumItems.pickupPlace,
      switchboard: true,
      defaultShow: false,
    },
    includes: {
      name: 'Includes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    availability: {
      name: 'Availability',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description: {
      name: 'Description',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description_en: {
      name: 'Description EN',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description_fr: {
      name: 'Description FR',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    description_de: {
      name: 'Description DE',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    booking_informations: {
      name: 'Booking Information',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    bus_included: {
      name: 'Bus Included',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      defaultShow: true,
    },
    city_transfer: {
      name: 'City Transfer',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      defaultShow: false,
    },
    city_transfer_duration: {
      name: 'Transfer Duration',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    city_transfer_distance: {
      name: 'Distance',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      defaultShow: false,
    },
    bad_weather_plan: {
      name: 'Bad Weather Plan',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    flight_delay_plan: {
      name: 'Flight Delay Plan',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    guide_infos: {
      name: 'Guide Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    guide_schedule_infos: {
      name: 'Guide Schedule Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    client_infos: {
      name: 'Client Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    stripper_infos: {
      name: 'Stripper Infos',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    duty_info: {
      name: 'Duty Info',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    duration: {
      name: 'Duration',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    full_duration: {
      name: 'Full Duration',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    pickup_time_delta: {
      name: 'Pickup Time Delta',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    meeting_time_delta: {
      name: 'Meeting Time Delta',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    latest_activity_start: {
      name: 'Latest Activity Start',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    guide_work_hours: {
      name: 'Guide Work Hours',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
      defaultShow: false,
    },
    extra_sales_commission: {
      name: 'Extra Sales Commission',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      defaultShow: false,
    },
    appointments: {
      name: 'Appointments',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      defaultShow: false,
    },
    active: {
      name: 'Active',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      section: 'general',
      defaultShow: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/activities'),
};
